import { render, staticRenderFns } from "./CardEdital.vue?vue&type=template&id=eb072c2a&scoped=true&lang=pug&"
import script from "./CardEdital.vue?vue&type=script&lang=js&"
export * from "./CardEdital.vue?vue&type=script&lang=js&"
import style0 from "./CardEdital.vue?vue&type=style&index=0&id=eb072c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb072c2a",
  null
  
)

export default component.exports